import { supabase } from './supabaseClient';
import { EmailStats, UnifiedEmailRecord } from '@/types/emails';

export class EmailService {


  static async getEmailStats(userId: string): Promise<EmailStats> {
    const today = new Date().toISOString().split('T')[0];

    const [pendingCount, awaitingPreviewCount, sentTodayCount, failedCount] = await Promise.all([
      supabase
        .from('email_jobs')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', userId)
        .in('status', ['awaiting_transcript', 'generating', 'awaiting_preview', 'sending']),

      supabase
        .from('email_jobs')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', userId)
        .eq('status', 'awaiting_preview'),

      supabase
        .from('sent_emails')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', userId)
        .gte('sent_at', today),

      supabase
        .from('email_jobs')
        .select('id', { count: 'exact', head: true })
        .eq('user_id', userId)
        .eq('status', 'failed')
    ]);

    return {
      total_pending: pendingCount.count || 0,
      total_awaiting_preview: awaitingPreviewCount.count || 0,
      total_sent_today: sentTodayCount.count || 0,
      total_failed: failedCount.count || 0
    };
  }


  static async updateEmailAddress(jobId: string, newEmail: string): Promise<void> {
    const { error } = await supabase
      .from('email_jobs')
      .update({
        recipient_email: newEmail,
      })
      .eq('id', jobId);

    if (error) {
      console.error('Error updating email address:', error);
      throw error;
    }
  }

  static async resendEmail(jobId: string): Promise<void> {
    const { error } = await supabase
      .from('email_jobs')
      .update({
        error_message: null, 
        status: 'awaiting_preview', 
        preview_status: 'approved',
        retry_count: 0 
      })
      .eq('id', jobId);

    if (error) {
      console.error('Error resending email:', error);
      throw error;
    }
  }

  static async deleteEmailJob(jobId: string): Promise<void> {
    const { data, error } = await supabase
    .from('email_jobs')
    .delete()
    .eq('id', jobId);
  
  console.log('Deletion result:', data);
    
    if (error) {
      console.error('Error deleting email job:', error);
      throw error;
    }
  }

  static async getAllEmailsWithSearch(
    userId: string, 
    page = 1, 
    pageSize = 10, 
    searchTerm = '', 
    statusFilter = 'all'
  ): Promise<{ data: UnifiedEmailRecord[], pagination: any }> {
    
    const { data: result, error } = await supabase.rpc('search_all_emails', {
      p_user_id: userId,
      p_search_term: searchTerm,
      p_status_filter: statusFilter,
      p_page: page,
      p_page_size: pageSize
    });
    if (error) {
      console.error('Error fetching unified email data:', error);
      throw error;
    }

    const emailData = result?.data || [];
    const totalCount = result?.total_count || 0;
    const totalPages = Math.ceil(totalCount / pageSize);
    const actualResults = emailData.length;
    const displayStart = actualResults > 0 ? ((page - 1) * pageSize) + 1 : 0;
    const displayEnd = actualResults > 0 ? displayStart + actualResults - 1 : 0;
    return {
      data: emailData,
      pagination: {
        page,
        pageSize,
        total: totalCount,
        totalPages,
        hasNextPage: page < totalPages,
        hasPrevPage: page > 1,
        displayStart,
        displayEnd,
        actualResults,
      }
    };
  }
} 